import React, { useState, useEffect } from 'react'
import { Row, Col ,  Button, Form } from 'antd';
import { default as ContributionDetails } from "./fnContributionDetails"
import ContributionsTable from "./ContributionsTable"
import { getFundsApi, getContributionByMemberApi, getContributorApi } from '../../services/apiService'
import { showApiError } from '../utilities'
import { record_operation } from '../enums'
import moment from 'moment'

export default function ContributionsByMember(props) {

  let memberId = props.match.params.id ? props.match.params.id : 0
  const [funds , setFunds ] = useState([])
  const [data, setData] = useState({ contributions: [], selectedRow: -1, contribution: null } )
  //const [selectedRow, setSelectedRow] = useState(0)
  const [member, setMember] = useState({ memberName:"" , offeringNo: 0, contributorId:0, organisationId:0 } )
  //const [contributionRow, setContributionRow] = useState( {selectedRow: -1, contribution: null} )

  useEffect(() => {
    getFundsApi()
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {
          setFunds(json)
        }
      })
      .catch(error => {
        showApiError(error)
      })
  }, [])

  useEffect(() => {
    //console.log("use effect... ")
    getContributionByMemberApi(memberId)
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {
          if (json.length > 0) {
            //setData(json)
            //setContributionRow({ selectedRow: 0, contribution: json[0] })
            const newData = { contributions: json, selectedRow: 0, contribution: json[0] }
            setData(newData)
            setMember({ memberName: json[0].displayName, 
              offeringNo: json[0].offeringNo, 
              contributorId: json[0].contributorId,
              organisationId: json[0].organisationId }  )
          } else {
            getContributor(memberId)
          }
        }
      })
      .catch(error => {
        showApiError(error)
      })
  }, [])


  function getContributor(id) {
    getContributorApi(id)
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {

          //memberName = json.displayName
          //offeringNo = json.offeringNo
          setMember({ memberName: json.displayName, 
            offeringNo: json.offeringNo,
            contributorId: json.id,
            organisationId: json.organisationId
          })
          //console.log( 'getContributor: ' + memberName )
        }
      })
      .catch(error => {
        showApiError(error)
      })
  }

  function handleSelectRow(id) {
    const contributions = data.contributions
    if(contributions.length > 0) {
      let selectedRow = contributions.findIndex((c) => c.contributionId === id)
      let contribution = contributions.find((c) => c.contributionId === id)

      setData({ contributions, selectedRow, contribution })
      }
  }

  function handlePostSave(json, operation) {
    //console.log('handlePostSave')
    let Id = -1
    if (operation !== record_operation.DELETE) {
      Id = json.contributionId
    }
    getContributionByMemberApi(memberId)
    .then(json => {
      if (typeof json === 'string') {
        throw new Error(json)
      } else {
        if (json.length > 0) {

          let Index = json.findIndex(contribution => contribution.contributionId === Id) 
          Index = Index > -1 ? Index : 0
          const newData = { contributions: json, selectedRow: Index, contribution: json[Index] }
          setData(newData)
          //console.log("after handlePostSave setData")
        } else {
                 
          setData({ contributions: [], selectedRow: -1, contribution: null })
        }
      }
    })
    .catch(error => {
      showApiError(error)
    })

  }

  function defaultlines() {
    let lines = []
    let newId = -1
    funds
      .filter((f) => f.active)
      .map((f) => {
        lines.push({
          "fund": f.description,
          "amount": "",
          "contributionLineId": newId
        })
        newId = newId - 1
        return f
      })
    return lines
  }

  function getNewContribution() {

    let contributionDate = moment().format("YYYY-MM-DD")  // only want to date part
    //console.log(contributionDate)  
    return {
      organisationId: member.organisationId,
      contributionId: -1,
      contributionDate: contributionDate ,
      contributorId: member.contributorId,
      "offeringNo": member.offeringNo,
      "displayName": member.memberName,
      "contributionLines": defaultlines()
    }
  }

  function setContribution(newRecord) {
    const newData = { ...data, contribution: newRecord }
    setData(newData)
  }

  function handleAdd() {
    //console.log("adding new row")
    let newContribution = getNewContribution()
    //console.log(newContribution)
    const newData = { contributions: data.contributions, selectedRow: -1, contribution: newContribution }
    setData(newData)

  }
  //console.log("data.contribution")
  //console.log(data.contribution) 
  return (
     
    <div className="content">
      <h2>{props.title}</h2>
      <Row>
        <Col span={12} style={{ paddingRight: 5 }}>
          <TitleBar title={`(${member.offeringNo}) ${member.memberName}`} handleAdd={handleAdd} />
          <ContributionsTable contributions={data.contributions}
            selectedRow={data.selectedRow} firstColumn="date"
            rowClick={handleSelectRow} />
        </Col>
        <Col span={12}>
          {<ShowContributionDetails funds={funds} contribution={data.contribution} setContribution={setContribution}
            postSave={handlePostSave} />}
        </Col>
      </Row>
    </div>
  )
}


function ShowContributionDetails(props) {
  if (props.contribution) {
    //let key = props.contribution.contributionLines.map(item => item.contributionLineId).join("_")
    //console.log("key: " + key)
    return <ContributionDetails
      contribution={props.contribution} key={props.contribution.contributionId}
      contributionDate={props.contribution.contributionDate} postSave={props.postSave} setContribution={props.setContribution}
    funds={props.funds} />
    
  } 
  return null
}

function TitleBar(props) {
  return (
    <div className='panel'>
      <Form layout="inline">
      <Form.Item >
      <span >{props.title} </span>
      </Form.Item>
      <Form.Item style={{ float: 'right' }}>
      <Button  icon="plus" onClick={props.handleAdd} >Add</Button>
      </Form.Item>
      </Form>
    </div>
  )
}

//export default ContributionsByMember;